module.exports = "https://cdn-assessment.mathletics.com/app/100/assets/images/e20eca2c983a31b66b8b865775c42dd7.svg";